// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3FoMW","container1":"App_container1__2rZfm","image":"App_image__kkHhu","heading":"App_heading__bgC8v","helpline":"App_helpline__srEJ8"};